import { useEffect } from 'react'
import { useState } from 'react'
import NumberFormat from 'react-number-format'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Button from 'src/components/atoms/Button'
import InputWrap from 'src/components/molecules/InputWrap'
import Logo from 'src/logos/Logo'
import { editPersonalDetails, setPin as setPinAction, clearState } from 'src/slices/auth'
import { setEmail, verify } from 'src/slices/signup'
import { handleStatus } from 'src/slices/utils'
import css from './SetPin.module.scss'

export default function Verify() {
	const dispatch = useDispatch()
	const navigate = useNavigate()

	const [pin, setPin] = useState()
	const [confirm, setConfirm] = useState()

	const { status } = useSelector(state => state.auth)

	const params = useParams()
	const handlePinChange = (event, set) => {
		if (event.target.value.length <= 6) {
			set(event.target.value)
		}
	}
	useEffect(
		() =>
			handleStatus(status.setPin, () => dispatch(clearState(status.setPin)), {
				isSuccess: {
					callback: () => {
						navigate('/login')
					},
				},
			}),
		[status]
	)
	const handleSubmit = e => {
		if (e.key == 'Enter') {
			if (confirm != pin) {
				toast.warning(`'Pin' and 'Confirm Pin' must match.`)
			} else if (pin.match(/^[0-9]{6}$/g)) {
				dispatch(setPinAction(pin))
			} else {
				toast.warning('Pin must be 6 digits long.')
			}
		}
	}

	return (
		<div className={css.page}>
			<Logo
				height='60px'
				width='60px'
				hideText
			/>
			<h1>Welcome to Livecart!</h1>
			<p>
				You have successfully verified your email.
				<br />
				Please create a PIN to continue:
			</p>
			<form className={css.form}>
				<InputWrap
					component={
						<input
							type='number'
							value={pin}
							onChange={e => handlePinChange(e, setPin)}
						/>
					}
					label='PIN'
					helpText='Must be 6 digits long'
				/>
				<InputWrap
					component={
						<input
							type='number'
							value={confirm}
							onChange={e => handlePinChange(e, setConfirm)}
							onKeyUp={handleSubmit}
						/>
					}
					label='Confirm PIN'
				/>
			</form>

			<Button
				action={() => handleSubmit({ key: 'Enter' })}
				label='Set Pin'
				color='white'
				// href='us'
			/>
		</div>
	)
}
